// ---------------------------------------------------------------------------
// ตัวเชื่อมข้อมูลของแอป — ลำดับใช้งาน: Firebase RTDB (REACT_APP_FIREBASE_URL) > Google Sheets (Apps Script) > mock
//  - Firebase: เรียก src/services/fb ตรงจากหน้าเว็บ (ไม่มี server) ชื่อ action ตาม docs/API.md เหมือนเดิม
//  - Google Sheets (เลิกใช้แล้ว เก็บไว้เป็นทางเลือก):
//    อ่าน = GET ?key&action&auth&...   เขียน = POST text/plain (เลี่ยง CORS preflight)
//    token ผู้ใช้ส่งในพารามิเตอร์ `auth` = ค่าใน localStorage["scp-acc-tk"] ตรง ๆ ; response { status, data, message, code }
// ---------------------------------------------------------------------------
import { GS_URL, GS_KEY, IS_FB } from "./config";
import { getRawToken, clearSession } from "./apiClient";
import { fbCall } from "./fb";

const buildQuery = (params = {}) =>
  Object.entries({ key: GS_KEY, auth: getRawToken(), ...params })
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(typeof v === "object" ? JSON.stringify(v) : v)}`)
    .join("&");

const unwrap = async (response) => {
  const text = await response.text();
  let payload;
  try {
    payload = JSON.parse(text);
  } catch (e) {
    throw new Error("Google Sheets ตอบกลับไม่ใช่ JSON (ตรวจสอบว่า deploy เป็น Web app แบบ Anyone แล้ว)");
  }
  if (!payload.status && !payload.success) {
    const err = new Error(payload.message || "เรียก Google Sheets ไม่สำเร็จ");
    err.code = payload.code || "";
    if (err.code === "unauthorized") clearSession(); // token หมดอายุ/ไม่ถูกต้อง -> พาไป login
    throw err;
  }
  return payload.data;
};

const fbRun = async (action, params) => {
  try {
    return await fbCall(action, params);
  } catch (e) {
    if (e && e.code === "unauthorized") clearSession(); // token หมดอายุ/ไม่ถูกต้อง -> พาไป login
    throw e;
  }
};

export const gsGet = async (action, params = {}) =>
  IS_FB ? fbRun(action, params) : unwrap(await fetch(`${GS_URL}?${buildQuery({ action, ...params })}`, { method: "GET", redirect: "follow" }));

export const gsPost = async (action, body = {}) =>
  IS_FB
    ? fbRun(action, body)
    : unwrap(
        await fetch(GS_URL, {
          method: "POST",
          redirect: "follow",
          headers: { "Content-Type": "text/plain;charset=utf-8" },
          body: JSON.stringify({ key: GS_KEY, auth: getRawToken(), action, ...body }),
        })
      );
